<template>
  <div class="box">
    <sc-form
      ref="form"
      :form="form"
      :rules="rules"
      :hasStyle="false"
      :buttonsStyle="false"
      @submit="onGetReconAnalytics">
      <template slot="fields" slot-scope="{ fields, isValid }">
        <div class="columns is-multiline">
          <div class="column">
            <sc-field label="Centros de Distribuição" prop="warehouses">
              <sc-warehouse-dropdown
                v-model="fields.warehouses"
                @selectAll="(values) => fields.warehouses = values"
                @clearFilter="() => fields.warehouses = []"
                list-user
                dropdown />
            </sc-field>
          </div>

          <div class="column">
            <sc-field label="Transportadora" prop="logisticProviders">
              <sc-logistic-provider-dropdown
                v-model="fields.logisticProviders"
                @selectAll="(values) => fields.logisticProviders = values"
                @clearFilter="() => fields.logisticProviders = []"
                dropdown />
            </sc-field>
          </div>

         <div class="column">
            <sc-field label="Data de despacho" prop="dateRange">
              <sc-select v-model="fields.dateRange" expanded>
                <option
                    v-for="(item, index) in dateList"
                    :key="index"
                    :value="item.value">
                  {{item.label}}
                </option>
              </sc-select>
            </sc-field>
          </div>

        </div>
      </template>

      <template slot="actions" slot-scope="{ isValid }">
        <div class="columns sc-form__footer sc-analytics-filters__footer">
          <div class="column">
            <div class="buttons is-right">
              <sc-button
                :loading="loading"
                type="submit"
                theme="primary"
                text="Consultar"/>
            </div>
          </div>
        </div>
      </template>
    </sc-form>
  </div>
</template>

<script>
import {
  ScButton,
  ScField,
  ScForm,
  ScIcon,
  ScLogisticProviderDropdown,
  ScPageBase,
  ScRangeDatePicker,
  ScSelect,
  ScWarehouseDropdown,
 } from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations } = createNamespacedHelpers('recon/analytics/filters');

export default {
  name: 'sc-analytics-filters',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dateList: [
        {
          label: 'Último dia',
          value: 'D1',
          day: 1,
        },
        {
          label: 'Últimos 7 dias',
          value: 'D7',
          day: 7,
        },
        {
          label: 'Últimos 15 dias',
          value: 'D15',
          day: 15,
        },
        {
          label: 'Últimos 30 dias',
          value: 'D30',
          day: 30,
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'form',
    ]),
    rules() {
      return {
        warehouses: [
          {
            required: true,
            message: 'Selecione pelo menos um Centro de Distribuição',
          },
        ],
        dateRange: [
          {
            required: true,
            message: 'Selecione uma data',
          },
        ],
      };
    },
  },
  methods: {
    ...mapMutations([
      'setForm',
    ]),
    onGetReconAnalytics(form) {
      this.setForm(form);
      this.$emit('form-submit', form);
    },
  },
  mounted() {
    this.$emit('form-submit', this.form);
  },
  components: {
    ScButton,
    ScField,
    ScForm,
    ScIcon,
    ScLogisticProviderDropdown,
    ScPageBase,
    ScRangeDatePicker,
    ScSelect,
    ScWarehouseDropdown,
  },
};
</script>

<style lang="scss" scoped>
.sc-analytics-filters {
  &__footer {
    &.sc-form__footer {
      background-color: whitesmoke;
      border-top: 1px solid #e7e7e7;
      margin: 1.25rem -1.25rem -1.25rem -1.25rem;
      padding: 0.5rem;
      border-radius: 0 0 5px 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-filters/ScAnalyticsFilters.vue?4e843184